import { ref } from 'vue'
import { useShopwareContext } from '#imports'
import type { Schemas } from '#shopware'

type Experience = Schemas['A4gExperience']

export const useExperiences = () => {
    const experiences = ref<Experience[]>([])
    const totalCount = ref(0)
    const loading = ref(false)

    const { apiClient } = useShopwareContext()

    async function fetchExperiences(params: {
        ids: string[]
        page?: number
        limit?: number
        append?: boolean
    }): Promise<{ elements: Experience[], total: number } | null> {
        if (params.ids.length === 0) return null

        loading.value = true
        try {
            const body: {
                slides: string[]
                p?: number
                slidesPerPage?: number
                associations: Record<string, object>
            } = {
                slides: params.ids,
                associations: { translations: {} }
            }

            if (params.page) body.p = params.page
            if (params.limit) body.slidesPerPage = params.limit

            const { data } = await apiClient.invoke('readExperiences post /experiences', { body })

            return {
                elements: data?.searchResult?.elements ?? [],
                total: data?.searchResult?.total ?? 0,
            }
        } catch (e) {
            console.error('Failed to fetch experiences:', e)
            return null
        } finally {
            loading.value = false
        }
    }

    return { experiences, totalCount, loading, fetchExperiences }
}
